@if (isVisible()) {
@let message = environment() | translate;
<a
    class="github-fork-ribbon"
    (click)="ribbonClicked($event)"
    [attr.data-ribbon]="message"
    href="#"
    [title]="message">
    {{message}}
</a>
}